import { render } from "./TabsInspeccionComponent.vue?vue&type=template&id=5d57415e"
import script from "./TabsInspeccionComponent.vue?vue&type=script&lang=js"
export * from "./TabsInspeccionComponent.vue?vue&type=script&lang=js"

import "./TabsInspeccionComponent.vue?vue&type=style&index=0&id=5d57415e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__